import styled from 'styled-components';
import {
  Icon as SemanticIcon,
  TextArea,
} from 'semantic-ui-react';

import {
  Button as ButtonLayoutComponent,
  ErrorHandler,
} from '@playbookux/playbook-web-core';

import ImportedUploadButton from '../../../../../core/components/upload-file-button';

export const TopContainer = styled.div`
  width: 100%;
`;

export const ContentContainer = styled.div`
`;

export const Row = styled.div`
  display: flex;
`;

export const HeaderRow = styled(Row)`
  margin-top: 40px;
`;

export const NameInputRow = styled(Row)`
  margin-top: 20px;
  flex-direction: column;
`;

export const ButtonsRow = styled(Row)`
  margin-top: 40px;
  justify-content: space-between;
`;

export const BaseContainer = styled.div`
  display: flex;
  width: 100%;
  margin-top: 80px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Link = styled.a`
  margin-left: 100px;
`;

export const Title = styled.h1`
`;

export const TopicTitle = styled.h2`
  margin-bottom: 2px;
`;

export const TopicDescription = styled.p`
`;

// FIXME: using the TextAreaInput from playbook-web-core doesnt work
// because TextAreaInput only works with formik and doesnt make sense? it was copy paste from the folder playbook-web/core
export const NameInput = styled(TextArea)`
  &&& {
    display: flex;
    padding: 10px;
    height: ${(props) => (props.height ? props.height : '66px')};
    min-width: ${(props) => (props.minwidth ? props.minwidth : '0px')};
    border-color: rgb(222, 222, 223);
    resize: vertical;
    color: rgb(94, 108, 132);
    font-family: Roboto;
    &:focus {
      border-color: #477ae9;
      color: rgba(0, 0, 0, 0.8);
    }
  }
`;

export const UploadConsentFormRow = styled(Row)`
  margin-top: 20px;
  flex-direction: column;
`;

export const Italics = styled.span`
  font-style: italic;
  font-weight: normal;
`;

export const UploadButton = styled(ImportedUploadButton)``;

export const UploadButtonContainer = styled.div`
  height: 40px;
`;

export const UploadCompletedMessageContainer = styled.div`
  color: #248f24;
`;

export const Icon = styled(SemanticIcon)`
  &&&& {
    color: #248f24;
    opacity: 1;
    cursor: pointer;
    height: unset;
  }
`;

export const UploadErrorHandler = styled(ErrorHandler)``;

export const UploadErrorContainer = styled.div`
  margin-top: 10px;
`;

export const SubmitButton = styled(ButtonLayoutComponent)`
  &.ui.button {
    width: 100px;
    cursor: pointer;
  }
`;

export const CancelButton = styled(ButtonLayoutComponent.Inverted)`
  &.ui.button {
    width: 100px;
    cursor: pointer;
  }
`;
